<template>
  <div class="school">
    <div class="top">
      <span>案例中心/校园赋能</span>
      <span>打造高效智能的学生管理工具，轻松实现校园管理</span>
    </div>
    <h3>合作学校案例</h3>
    <div class="short_stub">
      <div></div>
      <div></div>
    </div>
    <div class="school_c">
      <div
        :class="index == showIndex?'school_i_p':'school_i_n'"
        v-for="(item, index) in schoolList"
        :key="index"
        @mouseover="showItem(index)"
      >
        <img src="//static.h5.ylmob.com/website/img/yinghao.png" />
        <span>{{item}}</span>
        <div v-if="index == showIndex" class="btn_check">
          <span>查看案例</span>
          <img src="//static.h5.ylmob.com/website/img/arrow_right.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      schoolList: [
        "广西来宾市良江初级中学",
        "广西来宾市第十一中",
        "浙江大学创新创业学院",
        "丽水市囿山小学",
        "逍林中心小学",
        "逍林镇东小学",
        "逍林初级中学",
        // "逍林实验幼儿园",
        // "逍林中心幼儿园",
        "嵊州市双塔小学",
        "绍兴市阳明小学"
      ],
      showIndex: -1
    };
  },
  computed: {},
  watch: {},
  methods: {
    showItem(index) {
      this.showIndex = index;
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
<style scoped>
.school {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background:rgba(246,246,246,1);
}
.top {
  width: 100%;
  height: 2.604167rem;
  background: url("//static.h5.ylmob.com/website/img/img_top_school.png")
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.top span:nth-child(1) {
  font-size: .3125rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: .3125rem;
}
.top span:nth-child(2) {
  font-size: .15625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  line-height: .15625rem;
  margin-top: 0.15625rem;
}
.school_c {
  width: 6.25rem;
  display: flex;
  align-items: center;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 0.3125rem;
}
.school_c:after {
  content: "";
  width: 1.942708rem;
}
.school_i_n {
  width: 1.942708rem;
  height: 1.041667rem;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 0.208333rem;
  /* opacity:0.5; */
}
.school_i_n img {
  width: 0.208333rem;
  height: 0.192708rem;
  opacity: 0.5;
}
.school_i_n span {
  font-size: 0.104167rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  line-height: 0.104167rem;
}
.school_i_p {
  width: 1.942708rem;
  height: 1.145833rem;
  background: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 0.15625rem;
  box-shadow:0px .15625rem .46875rem -.104167rem rgba(63,110,240,0.2);
}
.school_i_p img {
  width: 0.208333rem;
  height: 0.192708rem;
}
.school_i_p span {
  font-size: 0.104167rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  line-height: 0.104167rem;
}
.btn_check {
  width: 0.572917rem;
  height: 0.15625rem;
  background: rgba(63, 110, 240, 1);
  border-radius: 0.088542rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn_check span {
  font-size: 0.072917rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.072917rem;
}
.btn_check img {
  width: 0.072917rem;
  height: 0.072917rem;
  margin-left: 0.020833rem;
}
</style>